module.exports = "<div class=\"audioMediaCategoriesCon\" fxLayout=\"column\">\n  <!-- For Loading the images -->\n\n  <div fxLayout=\"column\" style=\"height:100%;\">\n    <app-commonaudio [bookObj]=\"bookObj\" [updateData]=\"audioDataUrl\" (onSelectGaudio)=\"addAudioUrl($event)\" style=\"height:100%\"></app-commonaudio>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component.html
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component.html
// module chunks = main